import Reac from "react";
import { useDispatch } from "reactn";
import { useHistory } from "react-router";
import { removeTemporaryTickets } from "io/localStorage";

export const useLogoutWithTemporaryUser = () => {
	const logOut = useDispatch("logout");
	const history = useHistory();

	const actionWithTemporary = (type) => {
		removeTemporaryTickets();
		logOut();
		if (type === "login") return history.push("/welcome");
		// if (type === "expired") return history.push("/");
		history.push("/signup");
	};

	return { actionWithTemporary };
};
